import LoyaltySelect from './loyalty-select.vue';

export default LoyaltySelect;
